module.exports = __webpack_public_path__ + "img/home-share.c3b0e324.png";